import { render } from "./Bind.vue?vue&type=template&id=50ed1ccd&scoped=true"
import script from "./Bind.vue?vue&type=script&lang=js"
export * from "./Bind.vue?vue&type=script&lang=js"

import "./Bind.vue?vue&type=style&index=0&id=50ed1ccd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ed1ccd"]])

export default __exports__